// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atomWithStorage } from 'jotai/utils';

// lib files
import createStorage from '@/lib/helpers/createStorage';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

interface PassportActivateState {
  membershipToken: string | null;
  membershipTokenError: string | null;
  membershipStationShortCommonName: string | null;
  membershipStationLogo: string | null;
  membershipStationCallsign: string | null;
  membershipStationId: string | null;
  membershipPk: number | null;
  membershipId: string | null;
  membershipEmail: string | null;
  uid: string | null;
};

const defaultPassportActivateState: PassportActivateState = {
  membershipToken: null,
  membershipTokenError: null,
  membershipStationShortCommonName: null,
  membershipStationLogo: null,
  membershipStationCallsign: null,
  membershipPk: null,
  membershipId: null,
  membershipStationId: null,
  membershipEmail: null,
  uid: null,
};

const storage = createStorage<PassportActivateState>('sessionStorage')

let storedActivateState = defaultPassportActivateState;

if (canAccessStorage('sessionStorage') && window.sessionStorage.getItem('passportState')) {
  storedActivateState = JSON.parse(window.sessionStorage.getItem('passportState')!) as PassportActivateState
}

const passportActivationAtom = atomWithStorage<PassportActivateState>('passportState', storedActivateState, storage);

export { passportActivationAtom, defaultPassportActivateState };
